import React, { useEffect } from "react";
import { ArrowBack, ArrowForward, EmailOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";

const SendgrindReview = props => {
  const { onNext, emailUserName, emailDomain, onStep } = props;

  useEffect(() => {
    if (!emailUserName || !emailDomain) {
      onStep(1);
    }
  }, [emailUserName, emailDomain, onStep]);

  return (
    <React.Fragment>
      {/* {loading ? <FullPageProgress fixed={true} /> : null} */}
      <div className="events-page-setup-steps-body">
        <div className="events-page-setup-steps-body-label">
          CONFIGURE EMAIL DOMAIN
        </div>
        <div className="events-page-setup-steps-body-title mb-20">
          Review and Set Up
        </div>

        <Flex className="events-sendgrid-box mb-20">
          <div className="events-sendgrid-box-icon">
            <EmailOutlined />
          </div>
          <div className="events-sendgrid-box-list">
            <div
              className="events-sendgrid-box-title"
              htmlFor="onboard-org-name"
            >
              Email Domain
            </div>

            <div className="events-sendgrid-box-list-row">
              <div className="events-sendgrid-box-list-text">Username:</div>
              <div className="events-sendgrid-box-list-value">
                {emailUserName}
              </div>
            </div>

            <div className="events-sendgrid-box-list-row">
              <div className="events-sendgrid-box-list-text">Domain:</div>
              <div className="events-sendgrid-box-list-value">
                {emailDomain}
              </div>
            </div>
          </div>
        </Flex>

        <Flex justify="center" gap="20" className="text-center ">
          <Button
            size="small"
            color="secondary"
            variant="outlined"
            className="events6ix-btn events6ix-btn-light mt-20"
            onClick={() => onStep(1)}
            startIcon={<ArrowBack />}
          >
            &nbsp; Back &nbsp;
          </Button>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="events6ix-btn  events6ix-btn-primary ml-20 mt-20"
            type="button"
            onClick={onNext}
            endIcon={<ArrowForward />}
          >
            continue
          </Button>
        </Flex>
      </div>
    </React.Fragment>
  );
};

export default SendgrindReview;
